const reviewLevelUp = {
  en: {
    action: 'Review level up', noteAction: 'Level up the whole note', title: 'Review level up',
    chooseSentence: 'Choose a sentence to review', question: 'Question',
    questionHint: 'Add a question or a hint for this sentence.', next: 'Choose destination',
    destination: 'Destination note', existing: 'Existing note', newNote: 'New note',
    name: 'New note name', create: 'Create review', creating: 'Creating review…',
    cancel: 'Cancel', close: 'Close', loading: 'Loading notes…', retry: 'Retry',
    created: 'Review created. Previous learning records have been preserved.', open: 'Open saved note',
    level: 'Level {from} → {to}', empty: 'There are no completed sentences to review.',
    noteHint: 'Copies every card into a new inactive note. Enable it when you are ready to practice.',
    targetHint: 'Choose another inactive note, or create one. Enable the saved note when you are ready to practice.',
    failed: 'Could not create the review. Please try again.',
  },
  ko: {
    action: '복습 레벨업', noteAction: '노트 전체 레벨업', title: '복습 레벨업',
    chooseSentence: '복습할 문장을 선택하세요', question: '질문 (Q)',
    questionHint: '이 문장을 떠올릴 질문이나 힌트를 입력하세요.', next: '저장할 노트 선택',
    destination: '저장할 노트', existing: '기존 노트', newNote: '새 노트',
    name: '새 노트 이름', create: '복습 생성', creating: '복습 생성 중…',
    cancel: '취소', close: '닫기', loading: '노트를 불러오는 중…', retry: '다시 시도',
    created: '복습을 생성했습니다. 이전 학습 기록은 그대로 유지됩니다.', open: '저장한 노트 열기',
    level: '레벨 {from} → {to}', empty: '복습할 수 있는 완료 문장이 없습니다.',
    noteHint: '모든 카드를 새 비활성 노트에 복제합니다. 학습할 때 새 노트를 활성화하세요.',
    targetHint: '다른 비활성 노트를 선택하거나 새로 만드세요. 학습할 때 저장한 노트를 활성화하세요.',
    failed: '복습을 생성하지 못했습니다. 다시 시도해 주세요.',
  },
};
export default reviewLevelUp;
